export enum MeetingEvent {
  SCHEDULED = 'MeetingEvent:SCHEDULED',
  DASHBOARD_MEETINGS_LOADED = 'MeetingEvent:DASHBOARD_MEETINGS_LOADED',
  DOCUMENT_UPDATED = 'MeetingEvent:DOCUMENT_UPDATED',
  STATUS_UPDATED = 'MeetingEvent.STATUS_UPDATED',
  ON_MEETING_SUCCESS_INTAKE_CONNECT_ACCOUNTS_CARD_CLIKED = 'MeetingEvent.ON_MEETING_SUCCESS_INTAKE_CONNECT_ACCOUNTS_CARD_CLIKED'
}
